import script from "./ml-tree-select.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-tree-select.vue?vue&type=script&setup=true&lang=js"

import "./ml-tree-select.vue?vue&type=style&index=0&id=1817f403&lang=scss"

const __exports__ = script;

export default __exports__